<template>
  <el-dialog :title="!dataForm.id ? '新增' : '修改'"
             :close-on-click-modal="false"
             :visible.sync="visible">
    <el-form :model="dataForm"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="类型"
                    prop="type">
        <el-select v-model="dataForm.type"
                   placeholder="请选择">
          <el-option key="0"
                     label="广告"
                     value="0">
          </el-option>
          <el-option key="1"
                     label="页面"
                     value="1">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述"
                    prop="descs">
        <el-input v-model="dataForm.descs"
                  placeholder="描述"></el-input>
      </el-form-item>
      <el-form-item label="值"
                    prop="text1">
        <el-input v-model="dataForm.text1"
                  placeholder="文本"></el-input>
      </el-form-item>
      <el-form-item label="广告图片"
                    prop="value1">
        <input id="fileSelector"
               type="file"
               @change="guanggaoimg" />
      </el-form-item>
      <el-form-item label="首图"
                    prop="img">
        <input id="fileSelector"
               type="file"
               @change="updateimg" />
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary"
                 @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import COS from 'cos-js-sdk-v5'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: 0,
        type: '',
        descs: '',
        text1: '',
        value1: '',
        img: '',
        createtime: ''
      },
      dataRule: {
        type: [
          { required: true, message: '类型不能为空', trigger: 'blur' }
        ],
        descs: [
          { required: true, message: '描述不能为空', trigger: 'blur' }
        ],
        text1: [
          { required: true, message: '文本不能为空', trigger: 'blur' }
        ],
        value1: [
          { required: true, message: '值不能为空', trigger: 'blur' }
        ],
        img: [
          { required: true, message: '首图不能为空', trigger: 'blur' }
        ],
        createtime: [
          { required: true, message: '创建时间不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    COS
  },
  methods: {
    guanggaoimg (e) {
      var _this = this
      const file = e.target.files && e.target.files[0]
      /* 直接调用 cos sdk 的方法 */
      var cos = new COS({
        SecretId: 'AKID4zkFYr00sXyB93mEajgroVxADRaZRBHI',
        SecretKey: '2eCtUxHVba2QfliWBodOyLUZZZR87wc5'
      })
      cos.sliceUploadFile({
        Bucket: 'yunjixie-1317685697', /* 填写自己的 bucket，必须字段 */
        Region: 'ap-beijing', /* 存储桶所在地域，必须字段 */
        Key: _this.guid(), /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
        Body: file // 上传文件对象
      }, function (err, data) {
        if (err != null) {
        } else if (data != null) {
          var pingzheng = 'https://' + data.Location
          console.log(pingzheng)
          _this.$message({
            message: '上传成功',
            type: 'success'
          })
          _this.dataForm.img = pingzheng
        }
      })
    },
    updateimg (e) {
      var _this = this
      const file = e.target.files && e.target.files[0]
      /* 直接调用 cos sdk 的方法 */
      var cos = new COS({
        SecretId: 'AKID4zkFYr00sXyB93mEajgroVxADRaZRBHI',
        SecretKey: '2eCtUxHVba2QfliWBodOyLUZZZR87wc5'
      })
      cos.sliceUploadFile({
        Bucket: 'yunjixie-1317685697', /* 填写自己的 bucket，必须字段 */
        Region: 'ap-beijing', /* 存储桶所在地域，必须字段 */
        Key: _this.guid(), /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
        Body: file // 上传文件对象
      }, function (err, data) {
        if (err != null) {
        } else if (data != null) {
          var pingzheng = 'https://' + data.Location
          console.log(pingzheng)
          _this.$message({
            message: '上传成功',
            type: 'success'
          })
          _this.dataForm.value1 = pingzheng
        }
      })
    },
    guid () {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line one-var
        var r = Math.random() * 16 | 0,
          v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
      })
    },
    init (id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: `/jxjg/jgbanner/info/${this.dataForm.id}`,
            method: 'get',
            params: this.$http.adornParams()
          }).then((data) => {
            if (data && data.code === 0) {
              this.dataForm.type = data.jgbanner.type
              this.dataForm.descs = data.jgbanner.descs
              this.dataForm.text1 = data.jgbanner.text1
              this.dataForm.value1 = data.jgbanner.value1
              this.dataForm.img = data.jgbanner.img
              this.dataForm.createtime = data.jgbanner.createtime
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.global.apiUrl + `/jxjg/jgbanner/${!this.dataForm.id ? 'save' : 'update'}`,
            method: 'post',
            params: {
              'id': this.dataForm.id || undefined,
              'type': this.dataForm.type,
              'descs': this.dataForm.descs,
              'text1': this.dataForm.text1,
              'value1': this.dataForm.value1,
              'img': this.dataForm.img
            }
          }).then((data) => {
            data = data.body
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.visible = false
                  this.$emit('refreshDataList')
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/jgbanner-add-or-update.vue